import { useQuery } from "@tanstack/react-query";
import { CategoryService } from "../../services";
import { asQuery } from "../../services/common";
import { ONE_HOUR } from "./shared";

// All categories (public). Callers filter/sort/shape as needed.
export function useCategories() {
  return useQuery({
    queryKey: ["categories", "all"],
    queryFn: () => asQuery<any[]>(CategoryService.all({ keyword: "" })),
    staleTime: ONE_HOUR,
  });
}

// A single category by id (public) — paused until an id is provided.
export function useCategory(id?: string) {
  return useQuery({
    queryKey: ["categories", id],
    queryFn: () => asQuery<any>(CategoryService.getById(id as string)),
    enabled: !!id,
    staleTime: ONE_HOUR,
  });
}

// The synthetic "Other" category bundle used by the listing forms.
export function useOtherCategory() {
  return useQuery({
    queryKey: ["categories", "others"],
    queryFn: () => asQuery<any>(CategoryService.others()),
    staleTime: ONE_HOUR,
  });
}
